import { ReactComponent as TemplateIcon } from "assets/svg/fanFav.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const fanFavorite: SurveyTemplate = {
  icon: <TemplateIcon />,
  title: "Fan Favorite",
  description:
    "Offer your fans the ability to choose the focus of today's live: performance, demo leak, storytime or more.",
  templateId: "fanFavorite",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "Fan Favorite",
        },
      },
      ...getContestDefaults(formState),
    },
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-livestream-326e95"
        : "pp-livestream-a21a05",
    fields: [
      {
        name: "date",
        type: "text",
        label: "When does your livestream take place?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.date ? false : "This field cannot be left blank",
      },
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
